import authPromiseStore from "./authPromiseStore";
import LoadingState from "./LoadingState";

const createAuthFlowProcess = (): Promise<LoadingState> => {
  console.log("start re-auth flow");
  const output = new Promise<LoadingState>((resolve, reject) => {
    authPromiseStore.statusSubject.next(LoadingState.LOADING);
    authPromiseStore.statusSubject.subscribe((nextValue) => {
      if (nextValue === LoadingState.RESOLVED) {
        resolve(nextValue);
        console.log("re-auth flow resolved");
      } else if (nextValue === LoadingState.REJECTED) {
        reject(nextValue);
        console.log("re-auth flow rejected");
      }
    });

    console.log("in re-auth flow promise");
  });

  return output;
};

export default createAuthFlowProcess;
